import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	getIp: {
		data: {},
		isLoading: false,
		hasBeenLoaded: false,
		error: undefined
	},
	telemetry: {}
};

export const telemetrySlice = createSlice({
	name: 'telemetry',
	initialState,
	reducers: {
		getIp: (state) => {
			state.getIp.isBeingSubmitted = true;
		},
		getIpCompleted: (state, action) => {
			state.getIp.data = action.payload;
			state.getIp.error = undefined;
			state.getIp.isLoading = false;
			state.getIp.hasBeenLoaded = true;
		},
		getIpFailed: (state, action) => {
			state.getIp.isLoading = false;
			state.getIp.error = action.payload;
			state.getIp.hasBeenLoaded = false;
		},
		updateTelemetry: (state, action) => {
			state.telemetry = Object.assign({}, state.telemetry, action.payload);
		}
	}
});

export const { getIp, getIpCompleted, getIpFailed, updateTelemetry } =
	telemetrySlice.actions;

export default telemetrySlice.reducer;
